import React from 'react';
import cn from 'classname';
import { connect } from 'react-redux';
import moment from 'moment';

import UpdateDailyApproveComment from '../forms/update-daily-approve-comment';
import ModalBox from '../../../shared/modal';

import './main.less';

const Table = ({ table, intl, activeRowId, updateComment, requestTypes, sortByColumn, setActiveRow }) => (
	<div className="table-container daily-approve-lists-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{
						table.headers
							.map((header, i) =>
								<th
									key={i}
									className={cn({
										[header.className]: true,
										'sort-header': true,
										'active': table.sortedColumn.index === header.index,
										[table.sortedColumn.direction]: table.sortedColumn.index === header.index
									})}
									onClick={sortByColumn.bind(null, header.index)}
								>
									{intl(header.title)}
								</th>
							)
					}
				</tr>
			</thead>
			<tbody className="simple-table__body">
				{table.rows.map((row, i) => (
					<tr
						key={i}
						className={cn({ 'row-done': row.status === 'done', 'row-declined': row.status === 'declined' })}
					>
						<td
							className={`id fixed-col ${cn({
								'col-done': row.status === 'done', 'col-declined': row.status === 'declined'
							})}` }
						>
							<p><span>{row.manager}</span></p>
						</td>
						<td className="table-cell">
							<span>{row.affiliate} ({row.affiliate_id})</span>
						</td>
						<td className="table-cell">
							<span>{row.offer} ({row.offer_id})</span>
						</td>
						<td className="table-cell">
							<span>{row.country}</span>
						</td>
						<td className="table-cell">
							<span>{row.sid}</span>
						</td>
						<td className="table-cell">
							<span>{row.approve_percent}</span>
						</td>
						<td className="table-cell">
							<span>{row.minimum_leads_count}</span>
						</td>

						<td className="table-cell">
							<span>{row.start_leads_count}</span>
						</td>
						<td className="table-cell">
							<span>{moment(row.created_at).utc().format('YYYY-MM-DD')}</span>
						</td>
						<td className="table-cell">
							<span>
								{ row.removed_at
									? moment(row.removed_at).utc().format('YYYY-MM-DD')
									: ''
								}
							</span>
						</td>
						<td className="table-cell">
							<span>
								{ row.is_active ? 'Active' : 'Stopped' }
							</span>
						</td>
						<td className="table-cell">
							<span>
								{ row.is_on_period ? 'Да' : 'Нет' }
							</span>
						</td>
						<td className="table-cell">
							<span>
								{Math.floor(row.t80_hours)}
							</span>
						</td>
						<td className="table-cell">
							<span> CRM: {row.past_crm_valid_leads_count} </span>
							<span> CPA: {row.past_cpa_valid_leads_count} </span>
						</td>
						<td
							className="type-cell position-relative fixed-col-right table-cell"
							onClick={setActiveRow.bind(null, row.id)}
						>
							{activeRowId === row.id && (
								<ModalBox
									className="create-transfer-modal"
									body={(
										<UpdateDailyApproveComment
											form={`daily_approve_comment_${activeRowId}`}
											intl={intl}
											requestTypes={requestTypes}
											requestId={activeRowId}
											updateComment={updateComment}
											setActiveRow={setActiveRow}
											initialValues={{ comment: row.comment || '' }}
										/>
									)}
									isOpen={true}
									onClose={() => setActiveRow(null)}
								/>
							)}

							<span>{row.comment}</span>
						</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

class TableContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { activeRowId: null };
		this.setActiveRow = this.setActiveRow.bind(this);
	}

	setActiveRow(id) {
		this.setState({ activeRowId: id });
	}

	render() {
		return <Table {...this.props} activeRowId={this.state.activeRowId} setActiveRow={this.setActiveRow} />;
	}

}
export default connect(state => ({ requestTypes: state.root.lists['manual-approve-request-types'] }))(TableContainer);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/daily-approves-list/components/table/main.js